import { useParams } from 'react-router-dom';

import {
  Container, GridContainer, ImageContainer, SubGridContainer
} from './Article.styles';

import { useArticleCMS } from '../hooks/useArticleCMS';
import { componentRendering } from './dynamicRendering/componentRendering';

export const Article = () => {
  const { article } = useParams();
  const { content } = useArticleCMS(article);

  const [first, ...rest] = componentRendering(content);

  return (
    <Container aria-label="article">
      <GridContainer>
        <ImageContainer>{first}</ImageContainer>
        <SubGridContainer>{rest}</SubGridContainer>
      </GridContainer>
    </Container>
  );
};
